var exports = {
  "NQ": "xcc377c0b--12fec1--review",
  "Xk": "xcc377c0b--12fec1--review--link",
  "gX": "xcc377c0b--12fec1--review--link--rating",
};

module.exports = exports;
